import { serialize } from 'cookie'

const TOKEN_NAME = 'api_token'
const MAX_AGE = 5 * 24 * 60 * 60 * 1000

let cookieDomain = 'onepager.io'

if (process.env.NODE_ENV !== 'production') {
  cookieDomain = ''
}

function createCookie(name, data, options = {}) {
  return serialize(name, data, {
    // maxAge: MAX_AGE,
    expires: AddDays(5),
    // expires: new Date(Date.now() + MAX_AGE),
    secure: process.env.NODE_ENV === 'production',
    path: '/',
    httpOnly: true,
    sameSite: 'lax',
    domain: cookieDomain,
    ...options,
  })
}

function AddDays(days) {
  var today = new Date()
  var resultDate = new Date(today)
  resultDate.setDate(today.getDate() + days)
  return resultDate
}

function setTokenCookie(res, token, userID) {
  res.setHeader('Set-Cookie', [
    createCookie(TOKEN_NAME, token),
    createCookie('authed', true, { httpOnly: false }),
    createCookie('authed-user-id', userID, { httpOnly: false }),
  ])
}

function getAuthToken(cookies) {
  return cookies[TOKEN_NAME]
}

export default { setTokenCookie, getAuthToken }
